import React, { useCallback, useMemo } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DashboardPageHeader from "components/common/DashboardPageHeader";
import TrainingDeckViewer from "components/training/TrainingDeckViewer";
import { useAuth } from "hooks/useAuth";
import { DECK_BY_ROLE } from "services/trainingDeckService";
import { markRoleOrientationComplete } from "services/fde/roleOnboardingService";

const TciManagerOnboardingPage = () => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const hierarchyPath = useMemo(
    () => ({
      institutionId: userData?.institutionId || userData?.organizationId,
    }),
    [userData?.institutionId, userData?.organizationId],
  );

  const handleComplete = useCallback(async () => {
    await markRoleOrientationComplete({ tciManager: true });
    navigate("/dashboard/tci-manager");
  }, [navigate]);

  return (
    <Box sx={{ p: 3, maxWidth: 900, mx: "auto" }}>
      <DashboardPageHeader
        title="TCI Manager orientation"
        subtitle="Confirm your domain and review the candidate approval workflow."
      />
      <TrainingDeckViewer
        deckId={DECK_BY_ROLE["fde-dc"]}
        userHierarchyPath={hierarchyPath}
        onComplete={handleComplete}
      />
    </Box>
  );
};

export default TciManagerOnboardingPage;
